// import dishClassRefModel from './model/dishClassRefModel.js';
// import dishRefModel from './model/dishRefModel.js';
// import dishSelRefModel from './model/dishSelRefModel.js';
// import unitRefModel from './model/unitRefModel.js';
// import dishAndClassRefModel from './model/dishAndClassRefModel.js';
// import dishTreeMulRefModel from './model/dishTreeMulRefModel.js';
// import areaRefModel from './model/areaRefModel.js';
// import shopAndOgrRefModel from './model/shopAndOgrRefModel.js';
// import shopTreeMulRefModel from './model/shopTreeMulRefModel.js';
// import potTypeRefModel from './model/potTypeRefModel.js';
// import dishOutTypeRefModel from './model/dishOutTypeRefModel.js';
// import areaShopRefModel from './model/areaShopRefModel.js';
// import printTypeRefModel from './model/printTypeRefModel.js';
// import shopAndAreaRefModel from './model/shopAndAreaRefModel.js';
// import shopSelRefModel from './model/shopSelRefModel.js';
// import payWayRefModel from './model/payWayRefModel.js';
import dishClassReportModel from './model/dishClassReportModel.js';
import dishReportfModel from './model/dishReportModel.js';
// import orgRefModel from './model/orgRefModel.js';
// import unitRefSelectModel from './model/unitRefSelectModel.js';

export default{
	// 'dish-class':dishClassRefModel(),
    'dish-report':dishClassReportModel(),
	// 'dish':dishRefModel(),
	// 'dishSel':dishSelRefModel(),
    'dishReport':dishReportfModel(),
	// 'unit':unitRefModel(),
	// 'unitSel':unitRefSelectModel(),
	// 'dishAndClass':dishAndClassRefModel(),
	// 'dishMul':dishTreeMulRefModel(),
	// 'area':areaRefModel(),   //地区
	// 'shopAndOrg':shopAndOgrRefModel(), //门店+组织
	// 'shopMul':shopTreeMulRefModel(), //门店+组织
	// 'potType':potTypeRefModel(), //锅型
	// 'dishOutType':dishOutTypeRefModel(), //菜品外部分类参照
	// 'areaShop':areaShopRefModel(), //地区参照（仅含有门店的）
	// 'printType':printTypeRefModel(), //打印大类参照
	// 'shopAndArea':shopAndAreaRefModel(), //门店+地区
	// 'shopSel':shopSelRefModel(), //门店+地区
	// 'orgRef':orgRefModel(),//组织机构
	// 'payWay':payWayRefModel()//支付方式下拉
}


// WEBPACK FOOTER //
// ./src/pub/components/baseRef/refModelRouter.js